var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3.70996C19.5304 3.70996 20.0391 3.92067 20.4142 4.29575C20.7893 4.67082 21 5.17953 21 5.70996V19.71C21 20.2404 20.7893 20.7491 20.4142 21.1242C20.0391 21.4992 19.5304 21.71 19 21.71H5C4.46957 21.71 3.96086 21.4992 3.58579 21.1242C3.21071 20.7491 3 20.2404 3 19.71V5.70996C3 5.17953 3.21071 4.67082 3.58579 4.29575C3.96086 3.92067 4.46957 3.70996 5 3.70996H19ZM18.5 19.21V13.91C18.5 13.0454 18.1565 12.2162 17.5452 11.6048C16.9338 10.9934 16.1046 10.65 15.24 10.65C14.39 10.65 13.4 11.17 12.92 11.95V10.84H10.13V19.21H12.92V14.28C12.92 13.51 13.54 12.88 14.31 12.88C14.6813 12.88 15.0374 13.0275 15.2999 13.29C15.5625 13.5526 15.71 13.9087 15.71 14.28V19.21H18.5ZM6.88 9.26996C7.32556 9.26996 7.75288 9.09296 8.06794 8.7779C8.383 8.46284 8.56 8.03552 8.56 7.58996C8.56 6.65996 7.81 5.89996 6.88 5.89996C6.43178 5.89996 6.00193 6.07801 5.68499 6.39495C5.36805 6.71189 5.19 7.14175 5.19 7.58996C5.19 8.51996 5.95 9.26996 6.88 9.26996ZM8.27 19.21V10.84H5.5V19.21H8.27Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiLinkedin);
export default __webpack_public_path__ + "static/media/mdi_linkedin.3ccca0e394a322104a72b294dff18e0d.svg";
export { ForwardRef as ReactComponent };